export default __webpack_public_path__ + "static/media/1092.80fbae64.png";